import { useState } from 'react';
import { Container, Row, Col, Nav, Navbar, Offcanvas, Modal, Button } from 'react-bootstrap';
import {
  FaChalkboardTeacher, FaUserGraduate, FaTachometerAlt,
  FaPlayCircle, FaMoneyCheckAlt, FaCalendarCheck,
  FaCog, FaBook, FaSignOutAlt, FaFileInvoiceDollar, FaHandHoldingUsd,
  FaInbox,
} from 'react-icons/fa';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Layout.css';

const LINKS = [
  { to: '/admin/dashboard',    label: 'Dashboard',       icon: <FaTachometerAlt /> },
  { to: '/admin/teachers',     label: 'Teachers',        icon: <FaChalkboardTeacher /> },
  { to: '/admin/students',     label: 'Students',        icon: <FaUserGraduate /> },
  { to: '/admin/bookings',     label: 'Bookings',        icon: <FaFileInvoiceDollar /> },
  { to: '/admin/demos',        label: 'Demos',           icon: <FaPlayCircle /> },
  { to: '/admin/demo-requests', label: 'Demo Requests',  icon: <FaInbox /> },
  { to: '/admin/attendance',   label: 'Attendance',      icon: <FaCalendarCheck /> },
  { to: '/admin/payments',     label: 'Payments',        icon: <FaMoneyCheckAlt /> },
  { to: '/admin/settlements',  label: 'Settlements',     icon: <FaHandHoldingUsd /> },
  { to: '/admin/subjects',     label: 'Subjects',        icon: <FaBook /> },
  { to: '/admin/settings',     label: 'Settings',        icon: <FaCog /> },
];

export default function AdminLayout() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const close = () => setShowSidebar(false);
  const open = () => setShowSidebar(true);

  const doLogout = async () => {
    setShowLogout(false);
    await logout();
    navigate('/admin/login');
  };

  const renderLinks = () => (
    <Nav className="flex-column">
      {LINKS.map((l) => (
        <Nav.Link as={NavLink} to={l.to} key={l.to} onClick={close}>
          <span className="me-2">{l.icon}</span>{l.label}
        </Nav.Link>
      ))}
      <Nav.Link onClick={() => setShowLogout(true)}>
        <FaSignOutAlt className="me-2" />Logout
      </Nav.Link>
    </Nav>
  );

  return (
    <>
      <Navbar variant="dark" expand="lg" className="app-navbar px-3">
        <Navbar.Brand>Dial Tutor Admin</Navbar.Brand>
        <Navbar.Toggle onClick={open} />
        <Navbar.Collapse>
          <div className="ms-auto welcome-text">Welcome {user?.email}</div>
        </Navbar.Collapse>
      </Navbar>

      <Offcanvas show={showSidebar} onHide={close}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Dial Tutor Admin</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{renderLinks()}</Offcanvas.Body>
      </Offcanvas>

      <Container fluid>
        <Row>
          <Col md={2} className="d-none d-md-block sidebar p-3">{renderLinks()}</Col>
          <Col md={10} className="p-4 content"><Outlet /></Col>
        </Row>
      </Container>

      <Modal show={showLogout} onHide={() => setShowLogout(false)} centered>
        <Modal.Header closeButton><Modal.Title>Confirm Logout</Modal.Title></Modal.Header>
        <Modal.Body>Are you sure you want to exit?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>Cancel</Button>
          <Button variant="danger" onClick={doLogout}>Logout</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
